import { DateTime } from 'luxon';

import Validatable from '@/validator/Validatable';

export interface ICustomEventAPI {
  customevent_id: number;
  active: boolean;
  code: string;
  name: string;
  uuid: string;
  category_name: string;
}

export default class CustomEvent extends Validatable {
  id: number;

  isActive: boolean;

  code: string;

  name: string;

  uuid: string;

  categoryName: string;

  timestamp: DateTime;

  constructor(id: number, isActive = true, code: string, name: string, uuid: string, categoryName: string) {
    super();
    this.id = id;
    this.isActive = isActive;
    this.code = code;
    this.name = name;
    this.uuid = uuid;
    this.categoryName = categoryName;
    this.timestamp = DateTime.local();
  }

  static fromApi(apiObject: ICustomEventAPI): CustomEvent {
    return new CustomEvent(
      apiObject.customevent_id,
      apiObject.active,
      apiObject.code,
      apiObject.name,
      apiObject.uuid,
      apiObject.category_name,
    );
  }

  get endpoint(): string {
    return `/custom-events/${this.categoryName}/${this.id}`;
  }

  static fromObject(obj: CustomEvent): CustomEvent {
    return super.fromObject(obj, new CustomEvent());
  }

  toApi(): ICustomEventAPI {
    return {
      customevent_id: this.id,
      active: this.isActive,
      code: this.code,
      name: this.name,
      uuid: this.uuid,
      category_name: this.categoryName,
    };
  }

  static validatorCreateRules(): Record<string, string> {
    return {
      name: 'required|max:100|not_empty_or_whitespace',
      code: 'required|max:50|not_empty_or_whitespace',
      categoryName: 'required|max:100|not_empty_or_whitespace',
    };
  }
}
